import { Component } from '@angular/core';

@Component({
  standalone: false,
  templateUrl: '404.component.html'
})
export class P404Component {

  constructor() { }

}
